const getAssetProxy = (asset: string): string => {
  return asset ? asset.replace('a.storyblok.com/f/296868', 'storyblok-assets.output.com') : ''
}

export default getAssetProxy
